<div class="modal-overlay" [class.visible]="isVisible">
  <div class="modal-container">
    <div class="modal-header">
      <div class="header-content">
        <i class="fa-solid fa-sparkles sparkle-icon"></i>
        <h2>Content Pro Message Generator</h2>
      </div>
      <button
        aria-label="Close modal"
        type="button"
        class="close-button"
        (click)="onCancel()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="chat-column">
        <rn-content-pro-chat
          [messageId]="messageId"
          [emptyMessageContent]="emptyMessageContent"
          [productGroup]="productGroup"
          [clientId]="clientId"
          [language]="language"
          (contentProMessage)="onContentProMessage($event)"
          (contentProError)="onContentProError($event)"
          (contentProCancel)="onCancel()"
        ></rn-content-pro-chat>
      </div>

      <div class="preview-column">
        <div class="preview-content">
          <rn-focus-ai-preview
            [clientId]="clientId"
            [productGroup]="productGroup"
            [language]="language"
            [message]="generatedMessage"
            [errorMessage]="errorMessage"
            [instructionText]="'Your message preview will generate here.'"
            [feedback]="feedback"
            [phoneSize]="'medium'"
            [minResponsivePhoneWidth]="250"
            (feedbackChange)="onFeedbackChange($event)"
          ></rn-focus-ai-preview>
        </div>

        <div class="preview-footer">
          <button
            class="btn btn-primary apply-button"
            [disabled]="!generatedMessage || focusAiService.isGenerating()"
            (click)="onApplyClick()"
          >
            <span class="apply-button-label">
              Apply and continue editing in Message Builder
            </span>
          </button>
          <button
            [disabled]="focusAiService.isGenerating()"
            class="btn btn-link discard-link"
            (click)="onCancel()"
          >
            Discard and return to Message Builder
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Apply confirmation overlay -->
  @if (showConfirmation) {
  <div class="confirmation-overlay">
    <div
      class="confirmation-dialog"
      role="alertdialog"
      aria-labelledby="confirm-title"
      aria-describedby="confirm-desc"
    >
      <button
        class="close-button-confirm"
        (click)="onCancelConfirmation()"
        aria-label="Close confirmation"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

      <h3 id="confirm-title">Are you sure you want to apply this change?</h3>

      <p id="confirm-desc">
        This will replace the message content and Action Elements that currently
        exist in message builder with this new AI generated content. You will
        not be able to revert to previous content. You will also lose this
        ContentPro session including citations.
      </p>

      <div class="confirmation-buttons">
        <button
          class="btn btn-link cancel-confirmation"
          (click)="onCancelConfirmation()"
          data-testid="cancel-contentpro-confirmation"
        >
          Cancel
        </button>
        <button
          class="btn btn-primary confirm-apply"
          (click)="onConfirmApply()"
          data-testid="confirm-contentpro-apply"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Discard confirmation overlay -->
  @if (showDiscardConfirmation) {
  <div class="confirmation-overlay">
    <div
      class="confirmation-dialog"
      role="alertdialog"
      aria-labelledby="discard-title"
      aria-describedby="discard-desc"
    >
      <button
        class="close-button-confirm"
        (click)="onDiscardCancel()"
        aria-label="Close confirmation"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

      <h3 id="discard-title">Are you sure?</h3>

      <p id="discard-desc">
        Closing the Content Pro message creator will cause you to lose any
        message you have created. If you would like to keep your message, select
        “Apply to Message”.
      </p>

      <div class="confirmation-buttons">
        <button
          class="btn btn-link cancel-confirmation"
          (click)="onDiscardCancel()"
          data-testid="cancel-discard-confirmation"
        >
          Return to Content Pro
        </button>
        <button
          class="btn btn-primary confirm-apply"
          (click)="confirmDiscard()"
          data-testid="confirm-discard"
        >
          YES, CLOSE CONTENT PRO
        </button>
      </div>
    </div>
  </div>
  }
</div>
